import script from "./sign-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./sign-detail.vue?vue&type=script&setup=true&lang=js"

import "./sign-detail.vue?vue&type=style&index=0&id=70d99efe&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d99efe"]])

export default __exports__